
import React, { useState, useRef } from "react";
import { FaBars, FaTimes } from 'react-icons/fa';
import NavLink from "./navlink";
import useEscapeKey from "../utils/useEscapeKey";

const Hamburger = ({ links }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  const handleOptionClick = () => {
    setIsOpen(false);
  };

  useEscapeKey(handleOptionClick, isOpen);

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="relative inline-block text-left md:hidden">
        <button
          type="button"
          className="flex items-center justify-center rounded-full p-2 text-slate-300 transition-colors hover:bg-white/10 hover:text-white"
          id="menu-button"
          aria-label="Meny"
          aria-expanded={isOpen}
          onClick={toggleDropdown}
          ref={buttonRef}
        >
          {isOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
        </button>

        {isOpen &&
          <div
            className="absolute right-0 z-10 mt-3 min-w-48 overflow-hidden rounded-xl border border-white/10 bg-slate-900/95 text-white shadow-2xl backdrop-blur-md focus:outline-none"
            role="menu"
            tabIndex="-1"
            ref={dropdownRef}
          >
            <div className="flex flex-col p-2" role="none">
              {[...links, { target: "contact", title: "Kontakt" }].map((item) => (
                <NavLink target={item.target} key={item.target}>
                  <span
                    className="block rounded-lg px-3 py-2 text-sm text-slate-300 transition-colors duration-200 hover:bg-white/5 hover:text-white"
                    onClick={handleOptionClick}
                  >
                    {item.title}
                  </span>
                </NavLink>
              ))}
            </div>
          </div>}
      </div>
    </>
  );
};

export default Hamburger;